import React from 'react';

function RoundIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
      viewBox="0 0 22 10"
      fill="none"
    >
      <path
        d="M16.4917 3.67189H1.81167C1.07833 3.67189 0.478333 4.27189 0.478333 5.00523C0.478333 5.73856 1.07833 6.33856 1.81167 6.33856H16.4917V8.72523C16.4917 9.32523 17.2117 9.61856 17.625 9.19189L21.3317 5.47189C21.585 5.20523 21.585 4.79189 21.3317 4.52523L17.625 0.805226C17.2117 0.378559 16.4917 0.685226 16.4917 1.27189V3.67189V3.67189Z"
        fill="white"
      />
    </svg>
  );
}

export default RoundIcon;
